<template>
  <Form :model="formData"
        :rules="rules"
        class="step1__form"
        @on-validate="handleValidateFormItem"
        ref="form">
    <FormItem prop="phone">
      <Input type="text"
             placeholder="请输入手机号"
             element-id="phone"
             v-model.trim="formData.phone" />
    </FormItem>
    <FormItem prop="messageCode" class="forget-password__msg-valid-item">
      <Input type="text"
             placeholder="请输入短信验证码"
             element-id="messageCode"
             v-model="formData.messageCode" />
      <Button class="forget-password__msg-valid-btn"
              type="text"
              :disabled="isSendMsgBtnDisabled"
              @click="handleSendMsg"
      >{{sendMsgBtnText}}</Button>
    </FormItem>
    <FormItem prop="validateCode" class="forget-password__valid-form-item">
      <Input placeholder="请输入验证码"
             element-id="validateCode"
             v-model="formData.validateCode" />
      <div class="forget-password__valid-img">
        <img :src="validationCodeUrl"
             alt="验证码"/>
        <p @click="getValidationCode">看不清楚? 换一张</p>
      </div>
    </FormItem>
    <Button @click="handleSubmit"
            long
            :disabled="isSubmitDisabled"
            type="primary"
            :loading="loading"
            shape="circle"
            id="nextStep">下一步</Button>
  </Form>
</template>

<script>
import msgCode from '@/mixins/user/msgCode';
import validationCode from '@/mixins/user/validationCode';
import { forgetPasswordCheckPhone } from '@/api/user/user';

export default {
  name: 'step1',
  mixins: [msgCode, validationCode],
  data() {
    return {
      formData: {},
      rules: {
        phone: [{
          ...this.$rules.mobileNumber,
          required: true,
          message: '手机号码格式不正确，请重新输入',
          trigger: 'blur',
        }],
      },
      loading: false,
    };
  },
  computed: {
    isSubmitDisabled() {
      return !(this.$rules.mobileNumber.pattern.test(this.formData.phone)
            && this.formData.messageCode
            && this.formData.validateCode);
    },
  },
  methods: {
    async handleSubmit() {
      if (this.loading) {
        return false;
      }
      const valid = await this.$refs.form.validate();
      if (valid) {
        const {
          phone, messageCode, validateCode,
        } = this.formData;
        this.loading = true;
        const res = await forgetPasswordCheckPhone({
          phone,
          validation_code: validateCode,
          code: messageCode,
        });
        if (res) {
          this.$emit('on-submit', res);
        } else {
          this.getValidationCode();
        }
        this.loading = false;
      }
      return false;
    },
  },
};
</script>

<style lang="less">

</style>
